var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['pg-button', `pg-btn-${_vm.type}`, _vm.disabled ? 'pg-btn-disabled' : '', 'pg-size-' + _vm.size],on:{"click":function($event){_vm.disabled || _vm.loading ? '' : _vm.$emit('click')}}},[(_vm.loading)?_c('i',{staticClass:"loading-icon"},[_c('Icon',{attrs:{"type":"loading"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }